import { Validator } from '../../types/Validator';

const errorCode = 'REQUIRED';

const required: Validator = value => {
  if (Boolean(value) && Boolean(String(value).trim())) {
    return;
  }
  return { errorCode };
};

export { required, errorCode };
